import me from "models/me";
import app from "lib/app";
import { getStore } from "store";

export default function (type) {
    return function (nextState, replace, callback) {
        const { scope } = getStore().getState();
        let valid = false;

        switch (type) {
            case "buyer":
                if (me.account_type === "buyer" || me.account_type === "nuorder") {
                    valid = true;
                }
                break;
            /**
             * Might be temporary if we allow nuorder users access to /dashboard
             * without the active-brand restriction to fetching all orders.
             * Would require additional performance and validation testing.
             */
            case "buyer-only":
                if (me.account_type === "buyer") {
                    valid = true;
                }
                break;
            case "access-merchants":
                if (me.access_merchants) {
                    valid = true;
                }
                break;
            case "access-collections": {
                const hasAssortmentsMerchants =
                    me.merchant_connections &&
                    me.merchant_connections.find((mc) => mc.capabilities && mc.capabilities.includes("assortments"));

                if (
                    (me.account_type === "buyer" && me.hasCollectionsAccess()) ||
                    (me.account_type === "brand" &&
                        scope.brand &&
                        (scope.brand.hasModuleEnabled("drive") || scope.brand.hasModuleEnabled("assortments"))) ||
                    (me.account_type === "nuorder" && hasAssortmentsMerchants)
                ) {
                    valid = true;
                }
                break;
            }
            case "brand":
                if (me.account_type === "brand" || me.account_type === "nuorder") {
                    valid = true;
                }
                break;
            case "not-guest-buyer":
                valid = !me.isGuestBuyer();
                break;
            case "not-nuorder":
                valid = me.account_type !== "nuorder" && !me.actual_user;
                break;
            case "nuorder":
                if (me.account_type === "nuorder") {
                    valid = true;
                }
                break;
            default:
                break;
        }

        // scope.brand is null when the user is in /drive and refresh the page. We are fetching lastBrand to verify the drive/collections access
        if (type === "access-collections" && me.account_type === "brand" && scope.brand === null && me.last_brand) {
            app.brands.getOrFetch(me.last_brand, { handle401: true }, (err, model) => {
                process.nextTick(function () {
                    if (!err) {
                        valid = model.modules.drive.enabled || model.modules.assortments.enabled;
                    }
                    validateAndRedirect(valid, replace, callback);
                });
            });
            return;
        }
        validateAndRedirect(valid, replace, callback);
    };
}

function validateAndRedirect(valid, replace, callback) {
    if (!valid) {
        replace({
            pathname: "/404",
        });
    }
    callback();
}
